import './modules/swiper';

// Initialize any JavaScript functionality here
document.addEventListener('DOMContentLoaded', () => {
  console.log('App initialized');
});
